import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../../../components/New/Button";
import { routesURL } from "../../../../../../services/routesUrl";
import { wrapperRequests } from "../../../../../../services/api";
import { toastify } from "../../../../../../shared/Toastify";
import * as S from "./styles";

interface MarkOrderAsCanceledModalProps {
  orderId: string;
  onClose: () => void;
  onSuccess?: () => void | Promise<void>;
}

export function MarkOrderAsCanceledModal({
  orderId,
  onClose,
  onSuccess,
}: MarkOrderAsCanceledModalProps) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleMarkOrderAsCanceled = async () => {
    setIsLoading(true);

    try {
      await wrapperRequests(
        routesURL.report.orders.markOrderAsCanceled(orderId),
        "POST",
        { data: { internalReason: "N/A" } },
      );
    } catch (error) {
      toastify("error", t("markOrderAsCanceledError"), "top-center");
      setIsLoading(false);
      return;
    }

    toastify("success", t("markOrderAsCanceledCompleted"), "top-center");

    try {
      await onSuccess?.();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      onClose();
    }
  };

  return (
    <S.Container>
      <S.Disclaimer>{t("markOrderAsCanceledDisclaimer")}</S.Disclaimer>

      <S.ButtonContainer>
        <Button
          variant="ghost"
          title={t("goBack")}
          width="auto"
          disabled={isLoading}
          onClick={onClose}
        />

        <Button
          title={t("confirmMarkOrderAsCanceled")}
          width="auto"
          isLoading={isLoading}
          onClick={handleMarkOrderAsCanceled}
        />
      </S.ButtonContainer>
    </S.Container>
  );
}
